import styled from "styled-components";

import { WrapperButton } from "@ryde/controls";
import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { deepPurpleMui, greyMui, MOBILE_BREAKPOINT } from "@ryde/theme";

export const ReportToggleButtonStyled = styled(
  WrapperButton,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "report-toggle-button",
})`
  color: ${deepPurpleMui.A700};
  display: flex;
  align-items: center;
  gap: 3px;
  margin-inline-start: 9px;
  padding-block: 2px;
  padding-inline-start: 5px;
  border: 1px solid ${greyMui._300};
  border-radius: 4px;
  &:hover {
    border: 1px solid ${greyMui._400};
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  }
  label {
    margin-inline-start: 3px;
    cursor: pointer;
    font-size: 14px;
  }
  .ReportToggleButtonSVG {
    width: auto;
    height: 20px;
    display: block;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-inline-start: 2px;
  }
`;
